#import "../../../../common/graphql/TagEntityFields.graphql"

query Tags(
  $first: Int
  $after: Cursor
  $orderBy: [TagsOrderBy!]
  $filter: TagFilter
) {
  tags(first: $first, after: $after, orderBy: $orderBy, filter: $filter) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    nodes {
      ...TagEntityFields
    }
  }
}
